module.exports = __webpack_public_path__ + "media/assets/community/badge-osc-contributor-702bc46778006d3775db892625f63e8a6821ca211e9d582797596c495d2f6ca4.png";